import styled from "@emotion/styled";
import { Header } from "react-aria-components";
import { MDSMenuItemHeaderVariant } from "@/mds/components/menu/menu-item-header/menu-item-header.types";

export const StyledHeader = styled(Header)<{ $variant: MDSMenuItemHeaderVariant }>`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.text.secondary};
  padding-top: ${({ theme, $variant }) =>
    $variant === MDSMenuItemHeaderVariant.Beginning ? theme.spacing[2] : theme.spacing[3]};
  padding-bottom: ${({ theme }) => theme.spacing[2]};
  padding-inline: ${({ theme }) => theme.spacing[5]};
  background-color: ${({ theme }) => theme.colors.background.menu.default};
`;
